import React, { useCallback } from 'react';
import { MemberRowAction } from '../MemberRowTypes';
import { ProfilePictureModifier, ProfilePictureName } from '../../../../_lib/components/ProfilePictureName';
import { MemberType } from '../../../../types/api/MemberType';
import { Fieldset, Form, SonForm, SubmitButton, useForm } from '../../../../_lib/Form2';
import FormMultiselectContainer, {
  FormMultiselectModifier,
} from '../../Form/components/FormMultiselect/FormMultiselect';
import { useRefreshView } from '../../../../_lib/ViewFetcher';
import { useModalContext } from '../../../organisms/ModalDialog/ModalContext';
import { useSonTranslation } from '../../../../translation/useSonTranslation';
import { useDelayed } from '../../../../hooks/useDelayed';

type RoleChangeFormType = {
  form: SonForm<any>;
  member: MemberType;
};

export type MemberRole = {
  active: boolean;
  assignable: boolean;
  essentialRole: boolean;
  id: string;
  name: string;
  readOnly: boolean;
  text: string;
  value: string;
};

export function RoleChangeForm({ form, member }: RoleChangeFormType) {
  const { t } = useSonTranslation('MemberRow');
  const { refreshView } = useRefreshView();
  const { closeModal } = useModalContext();

  const refreshAndClose = useCallback(() => {
    refreshView();
    closeModal();
  }, [closeModal, refreshView]);
  const delayedRefreshAndClose = useDelayed(refreshAndClose);
  const onSuccess = () => {
    delayedRefreshAndClose();
  };

  const { formProps, fetchState, params } = useForm({ form, onSuccess });
  const rolesParam = params.getByName('roles');

  return (
    <Form id="role-change-form" {...formProps}>
      <Fieldset legend={t(`status.${MemberRowAction.editRoles}.label`)} modifier="like-label" required>
        <div className="member-row__role-change-form">
          <div className="member-row__role-change-form-column">
            <ProfilePictureName {...member} modifier={ProfilePictureModifier.ALIGN_TOP} />
            <input type="hidden" name="userId" value={member.id} />
          </div>
          <div className="member-row__role-change-form-column">
            <FormMultiselectContainer
              name="roles"
              title={t('glossary:role_plural')}
              items={rolesParam.options}
              modifier={FormMultiselectModifier.WIDTH_100}
            />
          </div>
        </div>
        <SubmitButton
          buttonLabel={t(`status.${MemberRowAction.editRoles}.saveChanges`)}
          messageSending={t('status.changeRoles.sending')}
          messageSuccess={t('status.changeRoles.success')}
          messageFail={t('status.changeRoles.fail')}
          fetchState={fetchState}
          customErrorTypeMessages={
            { invalidZeroCount: t(`status.changeRoles.invalidZeroCount`) }
          }
        />
      </Fieldset>
    </Form>
  );
}
